import { render, staticRenderFns } from "./select-reason.vue?vue&type=template&id=68ee39fc&"
import script from "./select-reason.vue?vue&type=script&lang=js&"
export * from "./select-reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports